<template>
  <section class="hero">
    <div class="hero__content">
      <h1 class="hero__title">
        {{ isEnglish ? 'Arynae digital agency' : 'Agence digitale Arynae' }}
      </h1>
      <p class="hero__subtitle">
        {{ isEnglish ? 'Optimize your digital strategy' : 'Optimisez votre stratégie digitale' }}
      </p>
      <ul class="hero__features">
        <li class="hero__feature hero__feature--purple">
          <span class="hero__dot"></span>
          No Code
        </li>
        <li class="hero__feature hero__feature--blue">
          <span class="hero__dot"></span>
          {{ isEnglish ? 'SEO solutions' : 'Solutions SEO' }}
        </li>
        <li class="hero__feature hero__feature--pink">
          <span class="hero__dot"></span>
          {{ isEnglish ? 'SaaS application' : 'Application SaaS' }}
        </li>
        <li class="hero__feature hero__feature--yellow">
          <span class="hero__dot"></span>
          {{ isEnglish ? 'AI Chatbot creation' : 'Création de chatbot IA' }}
        </li>
        <li class="hero__feature hero__feature--green">
          <span class="hero__dot"></span>
          Data Science
        </li>
      </ul>
    </div>
    <div class="hero__illustration">
      <object
        type="image/svg+xml"
        data="/img/arynae-animation.svg"
        class="hero__svg"
        style="width: 100%; max-width: 550px; height: auto; border: 2px solid white; border-radius: 22px;"
      ></object>
    </div>
    
    <div class="hero__background">
      <div class="hero__circle hero__circle--lg hero__circle--left"></div>
      <div class="hero__circle hero__circle--md hero__circle--center"></div>
      <div class="hero__circle hero__circle--sm hero__circle--right"></div>
      <div class="hero__waves"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  computed: {
    // Ajouter cette propriété calculée pour vérifier si on est en anglais
    isEnglish() {
      return this.$route.meta?.locale === 'en';
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.hero {
  display: flex;
  flex-direction: column;
  padding: $spacing-xl 0;
  gap: $spacing-xl;
  position: relative;
  overflow: hidden;
  border-radius: 0 0 $border-radius-xl $border-radius-xl;
  background: linear-gradient(135deg, #7400b8 0%, #5390d9 100%);
  color: $white;
  padding: $spacing-xl $spacing-lg;
  min-height: 400px;
  
  @media (min-width: $breakpoint-md) {
    flex-direction: row;
    align-items: center;
    gap: $spacing-xl;
  }
  
  &__background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    overflow: hidden;
  }
  
  &__circle {
    position: absolute;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.1);
    
    &--lg {
      width: 150px;
      height: 150px;
    }
    
    &--md {
      width: 100px;
      height: 100px;
    }
    
    &--sm {
      width: 70px;
      height: 70px;
    }
    
    &--left {
      top: 20px;
      left: 20px;
    }
    
    &--center {
      top: 50px;
      left: 50%;
      transform: translateX(-50%);
    }
    
    &--right {
      top: 40px;
      right: 20px;
    }
  }
  
  &__waves {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 120px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath d='M0,50 C150,20 350,80 500,50 C650,20 850,80 1000,50 C1150,20 1200,50 1200,50 L1200,120 L0,120 Z' fill='rgba(255,255,255,0.1)'/%3E%3Cpath d='M0,70 C150,40 350,100 500,70 C650,40 850,100 1000,70 C1150,40 1200,70 1200,70 L1200,120 L0,120 Z' fill='rgba(255,255,255,0.15)'/%3E%3Cpath d='M0,90 C150,60 350,120 500,90 C650,60 850,120 1000,90 C1150,60 1200,90 1200,90 L1200,120 L0,120 Z' fill='rgba(255,255,255,0.2)'/%3E%3C/svg%3E");
    background-size: cover;
    background-position: center;
  }
  
  &__content {
    flex: 1;
    position: relative;
    z-index: 1;
    background-color: white;
    color: $dark-text;
    padding: $spacing-md $spacing-lg;
    border-radius: $border-radius-lg;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    max-width: 400px;
  }
  
  &__title {
    font-size: 32px;
    font-weight: bold;
    color: $dark-text;
    margin-bottom: $spacing-xs;
    line-height: 1.2;
  }
  
  &__subtitle {
    font-size: 16px;
    color: $medium-text;
    margin-bottom: $spacing-md;
  }
  
  &__features {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  &__feature {
    display: flex;
    align-items: center;
    margin-bottom: $spacing-xs;
    font-size: 14px;
    
    &--purple .hero__dot {
      background-color: #7400b8;
    }
    
    &--blue .hero__dot {
      background-color: #5390d9;
    }
    
    &--pink .hero__dot {
      background-color: #ff006e;
    }

    &--yellow .hero__dot {
      background-color: #FFCE5B;
    }

    &--green .hero__dot {
      background-color: #3bb06f;
    }
  }
  
  &__dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: $spacing-xs;
  }
  
  &__illustration {
    flex: 1;
    max-width: 400px;
    position: relative;
    z-index: 1;
  }
  
  &__svg {
    width: 100%;
    height: auto;
  }
}


.hero__illustration {
  flex: 1;
  max-width: 410px; /* Taille maximale fixe */
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto; /* Centre la fenêtre horizontalement */
}

/* Pour les petits écrans */
@media (max-width: $breakpoint-md) {
  .hero__illustration {
    max-width: 100%;
  }
}

</style>